enum SearchTermsEnum {
	RAIO_X = 'Rx',
	TOMOGRAFIA = 'Tc',
	RESSONANCIA = 'RM',
	DOR_DE_CABECA = 'DOR DE CABECA CEFALEIA',
	ULTRASSONOGRAFIA = 'Us',
}

export {SearchTermsEnum};
